<!--
 * @Description: 睡眠时长
 * @Author: Zhang Xin (1483812724@qq.com)
 * @Date: 2023-08-23 10:10:44
 * @LastEditors: Wang Xiaowu (wangxiaowu@example.com)
 * @LastEditTime: 2023-11-15 16:39:42
 -->
<template>
  <div class="sleepDruation">
    <div class="eacharts">
      <echarts :chart-id="'sleepDruation'" :chart-option="options"></echarts>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
    sleepTime: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      options: {
        backgroundColor: "#fff",
        color: ["#514DF1", "#51AFF2", "#B1DE58", "#F9C570"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          formatter: function (x) {
            let date = x[0].data.year
            let shenshui = parseInt(x[0].data.深睡 / 60) + '时' + (x[0].data.深睡 % 60) + '分'
            let zhongshui = parseInt(x[0].data.中睡 / 60) + '时' + (x[0].data.中睡 % 60) + '分'
            let qianshui = parseInt(x[0].data.浅睡 / 60) + '时' + (x[0].data.浅睡 % 60) + '分'
            let qingxing = parseInt(x[0].data.清醒 / 60) + '时' + (x[0].data.清醒 % 60) + '分'
            let ss = '<div>' + '深睡：' + shenshui + '</div>'
            let zs = '<div>' + '中睡：' + zhongshui + '</div>'
            let qs = '<div>' + '浅睡：' + qianshui + '</div>'
            let qx = '<div>' + '清醒：' + qingxing + '</div>'
            let ddv = date + ss + zs + qs + qx
            return ddv
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          axisLine: {
            show: true,
            lineStyle: {
              color: "#7D7D7D", // x轴的颜色
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: "#393939", // X轴文字颜色
            },
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false,
            lineStyle: {
              color: "#eeeeee",
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: "#393939",
            fontSize: 14,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#e7e9ef",
              type: "dashed",
            },
          },
        },
        dataset: {
          dimensions: ["year", "深睡", "中睡", "浅睡", "清醒"],
          source: [],
        },
        series: [
          {
            type: "bar",
            stack: "总量",
            barMaxWidth: 20,
            label: {
              show: false,
              position: "inside",
            },
          },
          {
            type: "bar",
            stack: "总量",
            barMaxWidth: 20,
            label: {
              show: false,
              position: "inside",
            },
          },
          {
            type: "bar",
            stack: "总量",
            barMaxWidth: 20,
            label: {
              show: false,
              position: "inside",
            },
          },
          {
            type: "bar",
            stack: "总量",
            barMaxWidth: 20,
            label: {
              show: false,
              position: "inside",
            },
          },
        ],
      },
    };
  },
  created() {
    let data = [];
    let sss = { ...this.options };
    sss.dataset.source = [];
    this.sleepTime.list.forEach((item) => {
      data = {
        year: item.day,
        深睡: item.deepSleep
          ? Number(item.deepSleep.slice(0, 2) * 60) +
            Number(item.deepSleep.slice(3, 5))
          : "0",
        中睡: item.moderateSleep
          ? Number(item.moderateSleep.slice(0, 2) * 60) +
            Number(item.moderateSleep.slice(3, 5))
          : "0",
        浅睡: item.lightSleep
          ? Number(item.lightSleep.slice(0, 2) * 60) +
            Number(item.lightSleep.slice(3, 5))
          : "0",
        清醒: item.sober
          ? Number(item.sober.slice(0, 2) * 60) + Number(item.sober.slice(3, 5))
          : "0",
      };
      sss.dataset.source.push(data);
    });
    this.options = { ...sss };
  },
  watch: {
    sleepTime: {
      handler(newVal, oldVal) {
        if (newVal) {
          let data = [];
          this.sleepTime = newVal;
          let sss = { ...this.options };
          sss.dataset.source = [];
          this.sleepTime.list.forEach((item) => {
            data = {
              year: item.day,
              深睡: item.deepSleep
                ? Number(item.deepSleep.slice(0, 2) * 60) +
                  Number(item.deepSleep.slice(3, 5))
                : "0",
              中睡: item.moderateSleep
                ? Number(item.moderateSleep.slice(0, 2) * 60) +
                  Number(item.moderateSleep.slice(3, 5))
                : "0",
              浅睡: item.lightSleep
                ? Number(item.lightSleep.slice(0, 2) * 60) +
                  Number(item.lightSleep.slice(3, 5))
                : "0",
              清醒: item.sober
                ? Number(item.sober.slice(0, 2) * 60) +
                  Number(item.sober.slice(3, 5))
                : "0",
            };
            sss.dataset.source.push(data);
          });
          this.options = { ...sss };
        } else {
          this.sleepData = oldVal;
        }
      },
      deep: true,
      // immediate: true
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.sleepDruation {
  width: 100%;
  .eacharts {
    width: 100%;
    height: 200px;
  }
}
</style>